import { DOCUMENT_STATUS } from "../constant";

export const findEventStatus = (eventName, events) => {
    const event = events.find( event => event.name === eventName);
    return event?.status === DOCUMENT_STATUS.SUCCESS ? event.status : null;
}
